import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tokenExpire } from '../const';
@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(private http: HttpClient) { }

  tokenCheck() {
    return this.http.get<any>(`${tokenExpire}`)
  }

}
